import { defineStore } from 'pinia'
import EmployerService from "@/services/employer.service";
import AuthService from "@/services/auth.service.js";
import ProductService from "@/services/product.service.js";
export const useEmployerStore = defineStore('employer', {
    state: () => {
        return {
            employers: [],
            allowedRoles: [],
            paginate: {},
        }
    },
    persist: true,
    actions: {
        async getListEmployerWithLimit(url, params) {
            try {
                const res = await EmployerService.getListEmployers(url, params)
                this.employers = res.data.data
                this.paginate = res.data.meta
            } catch (e) {
                return null
            }
        },

        async getAllowedRoles(url, params) {
            try {
                const res = await EmployerService.getAllowedRoles(url, params)
                this.allowedRoles = res.data.data || [];
            } catch (e) {
                this.allowedRoles = [];
            }
        },

        async register(url, params) {
            try {
                const res = await EmployerService.register(url, params)
                return res.data;
            } catch (e) {
                return e
            }
        },

        async deleteEmployer(url, params) {
            try {
                const res = await EmployerService.deleteEmployer(url, params)
                return res.data
            } catch (e) {
                return null
            }
        },
    }
})
